<template>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>기간설정</strong></b-col>
          <b-col sm="2">
            <date-picker v-model="fullDateTmp"
                         type="date"
                         style="width: 100%;"
                         range
                         placeholder="조회기간 선택"
                         :lang="datepickerLang"
                         @change="handleDateRangeChange"/>
          </b-col>
          <b-col sm="6">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>



        </b-row>

        <!-- 기간설정 START -->
        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>

          <b-col sm="1"><strong>활성화</strong></b-col>
          <b-col sm="4" style="display: inline-flex;">
            <b-form-radio-group id="payorder-group" v-model="queryParams.active_yn" :options="active_yn_options" name="payorder-options"/>
          </b-col>
        </b-row>
        <!-- 기간설정 END -->

        <!-- 활성화 START -->
        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>

          <b-col sm="1"><strong>검색어</strong></b-col>
          <b-col sm="1">
            <b-form-select v-model="queryParams.search_type">
              <option value="total">전체</option>
              <option value="title">제목</option>
              <option value="content">내용</option>
            </b-form-select>
          </b-col>
          <b-col sm="7">
            <b-form-input v-model="queryParams.search_keyword" placeholder=""
                          v-on:keyup="$event.keyCode === 13 ? findMainManagementList() : ''"/>
          </b-col>
          <b-col sm="2" style="text-align: center;">
            <b-button variant="primary" style="width: 100%;" v-on:click="findMainManagementList()">검색</b-button>
          </b-col>

        </b-row>
        <!-- 활성화 END -->
      </b-card>
    </b-col>
  </b-row>
</template>
<script>

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'
import { EventBus } from "../../../event-bus";

export default {
  name: 'MainSearch',
  props: {
    queryParams: {
      type: Object
    },
    fullDate: {
      type: Array,
    },
    currentTab: {
      type: String
    },
  },
  components: {
    DatePicker
  },
  data () {
    return {
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },
      active_yn_options: [{text: '전체', value: 'all'}, {text: '활성', value: 'Y'}, {text: '비활성', value: 'N'}],
      fullDateTmp: [],
    }
  },
  mounted() {
    this.queryParams.banner_type = this.currentTab;
  },
  methods: {

    findMainManagementList() {
      this.queryParams.search_keyword = this.queryParams.search_keyword.replace(/\s/g, '');
      EventBus.$emit('callFindMain');
    },

    handleDateRangeChange() {
      this.$parent.fullDate = this.fullDateTmp;
      console.log('handleDateRangeChange >>>>', this.$parent.fullDate);
    },

    // 날짜 정의
    dateRange(flag) {
      let endDate;
      let startDate;
      if(this.fullDateTmp.length === 0){
        endDate = new Date();
        startDate = new Date();
      }else{
        endDate = this.fullDateTmp[1];
        startDate = _.clone(this.fullDateTmp[1]);
      }

      if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
        this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/site/main/component/MainSearch.vue